'use client'

import { SplineScene } from "@/components/ui/splite";
import { Card } from "@/components/ui/card"
import { Spotlight } from "@/components/ui/spotlight"
import { RainbowButton } from "@/components/ui/rainbow-button";
 
const Hero: React.FC = () => {
  return (
    <Card className="w-full min-h-screen bg-black/[0.96] relative border-0 rounded-none">
      <Spotlight
        className="-top-40 left-0 md:left-60 md:-top-20"
        fill="white"
      />
      
      <div className="flex min-h-screen container mx-auto">
        {/* Left content */}
        <div className="flex-1 pt-32 pb-8 px-8 relative z-10 flex flex-col justify-center max-w-xl">
          <h1 className="text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-b from-neutral-50 to-neutral-400">
            AI Consulting for Forward-Thinking Businesses
          </h1>
          <p className="mt-4 text-neutral-300 max-w-lg">
            We help businesses adopt AI strategically — identifying the right opportunities, building the roadmap, and delivering real results.
          </p>
          <div className="mt-8 mb-8">
            <RainbowButton>
              Get Started
            </RainbowButton>
          </div>
        </div>

        {/* Right content - Increased size for 3D scene */}
        <div className="hidden md:block flex-[1.5] relative overflow-visible">
          <div className="absolute inset-0 scale-125 translate-x-16 overflow-visible">
            <SplineScene
              scene="https://prod.spline.design/kZDDjO5HuC9GJUM2/scene.splinecode"
              className="w-full h-full overflow-visible"
            />
          </div>
        </div>
      </div>
    </Card>
  );
}

export default Hero;